// Shown when a margin is absent.
const absentMargin = '-'

export default {
  currency(value) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    if (!value) {
      value = 0
    }
    return `${i18n.n(this.fromString(value), 'currency')}`
  },

  currencyRounded(value) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    if (!value) {
      value = 0
    }
    return `${i18n.n(this.fromString(value), 'currencyRounded')}`
  },

  currencyRoundedDash(value) {
    return `${this.currencyRounded(value)},-`
  },

  // The backend strips MarginExcl / MarginPercentage for a dealer that hides the VCR or that it
  // cannot identify, so
  // these two are the only places a missing number must not read as zero.
  margin(value) {
    return value == null ? absentMargin : this.currency(value)
  },

  marginPercentage(value) {
    return value == null ? absentMargin : value
  },

  fromString(value) {
    // For NL formatted number strings, e.g. 1,99
    if (!value) {
      return null
    }
    return parseFloat(typeof value === 'string' ? value.replace(',', '.') : value)
  },
}
